import { cn } from '@/lib/cn'

interface Props {
  value: 'ATIVO' | 'INATIVO'
  /** Texto custom da tooltip. Default usa o próprio valor. */
  label?: string
  className?: string
}

/**
 * Bolinha de status compacta — substitui label textual ou toggle inline
 * em DataTables para economizar espaço (regra global).
 *
 *  - Verde  (`bg-emerald-500`) = ATIVO
 *  - Vermelha (`bg-rose-500`)  = INATIVO
 *
 * Tooltip nativa via atributo `title` (sem custo de runtime/portal).
 * Para alternar o status, o usuário entra na edição do registro.
 */
export function StatusDot({ value, label, className }: Props) {
  const isActive = value === 'ATIVO'
  const text = label ?? (isActive ? 'ATIVO' : 'INATIVO')
  return (
    <span
      role="img"
      aria-label={text}
      title={text}
      className={cn(
        'inline-block w-2.5 h-2.5 rounded-full ring-2 ring-offset-1 ring-offset-white',
        isActive ? 'bg-emerald-500 ring-emerald-200' : 'bg-rose-500 ring-rose-200',
        className,
      )}
    />
  )
}
